
/* tslint:disable:quotemark */
import { defineMessages } from "react-intl";


const MESSAGES = defineMessages({
  troughListMinValuesText: {
    id: "TroughListMinValuesText.text",
    defaultMessage: "min. washbasin width x depth",
  },
});

export default MESSAGES;